import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { MarketingCouponPoolResource } from "@exonn/js-sdk";
import { CouponPoolFormTabs } from "src/admin/modules/marketing-coupon-pool/constants.ts";

/**
 * Gutschein-Pools — коды, которые сгенерировал шоп и которые загружены сюда
 * из CSV. Из пула берут коды Anlasskampagnen и Empfehlungskampagnen.
 *
 * Модуль Voucher ERP здесь не участвует: его коды шоп не знает, и клиент не
 * смог бы их погасить (DEC-031, DEC-036). Поэтому кодов здесь не создают —
 * только загружают и, если код негоден, помечают.
 */
export const module: ModuleOptions<MarketingCouponPoolResource> = {
  resource: ResourceEnum.MarketingCouponPool,
  bigIcon: <span className={"icon-20-vouchers"} />,
  smallIcon: <span className={"icon-15-vouchers"} />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
  formTabs: {
    [CouponPoolFormTabs.General]: {
      title: (t) => t("formTabs.general.title"),
    },
    [CouponPoolFormTabs.Codes]: {
      title: (t) => t("formTabs.codes.title"),
    },
  },
};
